import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import Home from "Home.js";
import {Home2020, Home2021, Home2022, Home2023, Home2024} from "Home.js";

import AboutTheClub from "components/hero/TwoColumnWithInput.js";
import AdventCalendar from "components/features/AdventCalendar";
import ChristmaskCalendar from "components/christmask/ChristmaskCalendar";
import CommonwealthFencingChampionships2002 from "components/custom/CFC22";
import Location from "Location.js";
import TheHub from "TheHub.js";

export default function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route exact path="/">
          <Home/>
        </Route>
        <Route path="/2024">
          <Home2024 />
        </Route>
        <Route path="/2023">
          <Home2023 />
        </Route>
        <Route path="/2022">
          <Home2022 />
        </Route>
        <Route path="/2021">
          <Home2021 />
        </Route>
        <Route path="/2020">
          <Home2020 />
        </Route>
        <Route path="/Location">
          <Location />
        </Route>
        <Route path="/TheHub">
          <TheHub />
        </Route>
        <Route path="/AboutTheClub">
          <AboutTheClub />
        </Route>
        <Route path="/AdventCalendar">
          <AdventCalendar />
        </Route>
        <Route path="/CFC22">
          <CommonwealthFencingChampionships2002 />
        </Route>
        <Route path="/ChristmaskCalendar">
          <ChristmaskCalendar />
        </Route>
      </Switch>
    </Router>
  );
}